<template>
  <b-row>
    <b-col cols="9">
      <form-wizard-number />
    </b-col>
    <b-col cols="3">
     <timeline-basic :log_pengajuan="berkas.log_pengajuan"/>
    </b-col>
    <b-col cols="12">
      <div class="d-flex justify-content-center" v-if="berkas.role.includes('pembimbing') && (berkas.status_sidang_id === 1 || berkas.status_sidang_id === 7)">
        <div class="mr-1">
          <b-button v-b-modal.modal-center-pembimbing-terima variant="primary">Terima</b-button>
          <b-modal id="modal-center-pembimbing-terima" centered title="Konfirmasi" :hide-footer="true">
            <center><p>Apakah anda ya yakin ingin menerima berkas ini?</p></center>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="success" class="mr-1" @click="terimaBerkas(berkas.role)">Ya</b-button>
                <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-terima')">Tidak</b-button>
            </div>
          </b-modal>
        </div>

        <div>
          <b-button v-b-modal.modal-center-pembimbing-tolak variant="danger">Tolak</b-button>
          <b-modal id="modal-center-pembimbing-tolak" centered title="Konfirmasi" :hide-footer="true">
            <center><p>Berikan catatan penolakan</p></center>
            <b-form-textarea
              v-model="catatanPenolakan"
            />
            <div class="d-flex justify-content-center mt-2" v-if="catatanPenolakan !== null && catatanPenolakan !== ''">
                <b-button variant="success" class="mr-1" @click="tolakBerkas(berkas.role)">Kirim</b-button>
                <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-tolak')">Batal</b-button>
            </div>
            <div class="d-flex justify-content-center mt-2" v-else>
                <b-button variant="success" class="mr-1" disabled>Kirim</b-button>
                <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-tolak')">Batal</b-button>
            </div>
          </b-modal>
        </div>
      </div>

      <div class="justify-content-center" v-if="berkas.role.includes('ketua')">
        
        <div class="mr-1">
          <b-button v-b-modal.modal-center-reviewer-assign variant="primary">Menunjuk Reviewer</b-button>
          <b-modal v-model="modalReviewerVisible" id="modal-center-reviewer-assign" centered title="Pilih Reviewer" >
            <center><p>Silahkan Pilih Reviewer Kaji Etik</p></center>
            <b-row class="mt-3 mb-3" >
             <b-col md="12">
                <b-form-group
                  label="Reviewer 1"
                  label-for="Reviewer 1"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Reviewer 1"
                    rules="required"
                  >
                      <v-select
                      id="reviewer_1"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :reduce="val => val.value"
                      :options="dosenReviewerOption.options"
                      v-model="berkas.reviewer_1"
                      placeholder="Pilih Reviewer 1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Reviewer 2"
                  label-for="Reviewer 2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Reviewer 2"
                    rules="required"
                  >
                      <v-select
                      id="reviewer_2"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :reduce="val => val.value"
                      :options="dosenReviewerOption.options"
                      v-model="berkas.reviewer_2"
                      placeholder="Pilih Reviewer 2"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                  <b-form-group
                    label="Reviewer 3"
                    label-for="Reviewer 3"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Reviewer 3"
                    >
                        <v-select
                        id="reviewer_3"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :reduce="val => val.value"
                        :options="dosenReviewerOption.options"
                        v-model="berkas.reviewer_3"
                        placeholder="Pilih Reviewer 3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
              </b-col>
  <b-col md="12">
                    <b-form-group
                      label="Reviewer 4"
                      label-for="Reviewer 4"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Reviewer 4"
                      >
                          <v-select
                          id="reviewer_4"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          label="title"
                          :reduce="val => val.value"
                          :options="dosenReviewerOption.options"
                          v-model="berkas.reviewer_4"
                          placeholder="Pilih Reviewer 4"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                </b-col>
  <b-col md="12">
                    <b-form-group
                      label="Reviewer 5"
                      label-for="Reviewer 5"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Reviewer 5"
                      >
                          <v-select
                          id="reviewer_5"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          label="title"
                          :reduce="val => val.value"
                          :options="dosenReviewerOption.options"
                          v-model="berkas.reviewer_5"
                          placeholder="Pilih Reviewer 5"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                </b-col>
  <b-col md="12">
                    <b-form-group
                      label="Reviewer 6"
                      label-for="Reviewer 6"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Reviewer 6"
                      >
                          <v-select
                          id="reviewer_2"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          label="title"
                          :reduce="val => val.value"
                          :options="dosenReviewerOption.options"
                          v-model="berkas.reviewer_6"
                          placeholder="Pilih Reviewer 6"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                </b-col>
  <b-col md="12">
                    <b-form-group
                      label="Reviewer 7"
                      label-for="Reviewer 7"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Reviewer 7"
                      >
                          <v-select
                          id="reviewer_7"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          label="title"
                          :reduce="val => val.value"
                          :options="dosenReviewerOption.options"
                          v-model="berkas.reviewer_7"
                          placeholder="Pilih Reviewer 7"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                </b-col>
            </b-row>
            <template v-slot:modal-footer>
              <b-button variant="primary" @click="pilihReviewer(berkas.role)">Pilih</b-button>
            </template>
          </b-modal>
        </div>
      </div>
      <div class="d-flex justify-content-center" v-if="berkas.role.includes('superadmin') && (berkas.status_sidang_id == 2 || berkas.status_sidang_id == 7)">
        <div class="mr-1">
          <b-button v-b-modal.modal-center-pembimbing-terima variant="primary">Terima</b-button>
          <b-modal id="modal-center-pembimbing-terima" centered title="Konfirmasi" :hide-footer="true">
            <center><p>Apakah anda ya yakin ingin menerima berkas ini?</p></center>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="success" class="mr-1" @click="terimaBerkas(berkas.role)">Ya</b-button>
                <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-terima')">Tidak</b-button>
            </div>
          </b-modal>
        </div>

        <div>
          <b-button v-b-modal.modal-center-pembimbing-tolak variant="danger">Tolak</b-button>
          <b-modal id="modal-center-pembimbing-tolak" centered title="Konfirmasi" :hide-footer="true">
            <center><p>Berikan catatan penolakan</p></center>
            <b-form-textarea
              v-model="catatanPenolakan"
            />
            <div class="d-flex justify-content-center mt-2" v-if="catatanPenolakan !== null && catatanPenolakan !== ''">
                <b-button variant="success" class="mr-1" @click="tolakBerkas(berkas.role)">Kirim</b-button>
                <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-tolak')">Batal</b-button>
            </div>
            <div class="d-flex justify-content-center mt-2" v-else>
                <b-button variant="success" class="mr-1" disabled>Kirim</b-button>
                <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-tolak')">Batal</b-button>
            </div>
          </b-modal>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BButton, BContainer, BFormTextarea, BFormGroup  } from 'bootstrap-vue'
import vSelect from 'vue-select'
// import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import FormWizardNumber from './FormWizardNumber.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  checkExpired,
} from '@/connection-api/auth'
import {
  getPengajuanSidangDetail,
  postTerimaBerkas,
  postTolakBerkas,
  getDosen,
  getDosenReviewer,
} from '@/connection-api/master'
import TimelineBasic from './TimelineBasic.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    FormWizardNumber,
    BButton,
    BContainer,
    BFormTextarea,
    TimelineBasic,
    BFormGroup,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      berkas: {},
      catatanPenolakan: null,
      dosenOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Dosen --' },
        ],
      },
      dosenReviewerOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Dosen --' },
        ],
      },
      modalReviewerVisible: false,
      reviewer_1: null,
      reviewer_2: null,
    }
  },

  async mounted() {
    var error_check = []
    var success_check = []
    const response = await checkExpired()
    if(response.data.success === true)
    {
      if(response.data.biodata_complete === false)
      {
        this.$router.push({ name: 'pages-account-setting', params: {warning_show: true} })
      }
    }

    const response2 = await getPengajuanSidangDetail(this.$route.params.uuid)
    if(response2.data.success === true)
    {
      this.berkas = response2.data.data
    }

    getDosen()
      .then(response => {
        if (response.data.length > 0) {
          response.data.forEach(element => {
            this.dosenOption.options.push({
              title: element.nama,
              value: element.uuid,
            })
          })
          success_check.push('success')
          this.completeCheck(success_check)
        }
      })
      .catch(error => {
        error_check.push(error)
      });

    getDosenReviewer()
      .then(response => {
        if (response.data.length > 0) {
          response.data.forEach(element => {
            this.dosenReviewerOption.options.push({
              title: element.nama,
              value: element.uuid,
            })
          })
          success_check.push('success')
          this.completeCheck(success_check)
        }
      })
      .catch(error => {
        error_check.push(error)
      });
  },
  methods: {
    pilihReviewer(role) {
      if((this.berkas.reviewer_1 === null || this.berkas.reviewer_1 === undefined) && (this.berkas.reviewer_2 === null || this.berkas.reviewer_2 === undefined)){
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Pengajuan Kaji Etik',
            icon: 'EditIcon',
            variant: 'danger',
            text: 'Mohon pilih minimal 2 orang reviewer',
          }
        });
      } else {
        this.modalReviewerVisible = false;
        var data = {
          role: role,
          catatan: this.catatanPenolakan,
          uuid: this.$route.params.uuid,
          reviewer_1: this.berkas.reviewer_1,
          reviewer_2: this.berkas.reviewer_2,
          reviewer_3: this.berkas.reviewer_3,
          reviewer_4: this.berkas.reviewer_4,
          reviewer_5: this.berkas.reviewer_5,
          reviewer_6: this.berkas.reviewer_6,
          reviewer_7: this.berkas.reviewer_7,
        }
        postTerimaBerkas(data)
          .then(response => {
            if (response.data.success === true) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengajuan Kaji Etik',
                  icon: 'EditIcon',
                  variant: 'success',
                  text: 'Reviewer telah dipilih',
                },
              })
              setTimeout(() => {
                // this.$router.push({ name: 'list-kajietik' })
              }, 1000);
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengajuan Kaji Etik',
                  icon: 'EditIcon',
                  variant: 'danger',
                  text: response.data.message,
                },
              })
              setTimeout(() => {
                // this.$router.push({ name: 'list-kajietik' })
              }, 1000);
            }
          })
          .catch(error => console.log(error));
      }
    },
    terimaBerkas(role)
    {
      var data = {
        role: role,
        catatan: this.catatanPenolakan,
        uuid: this.$route.params.uuid,
      }
      postTerimaBerkas(data)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Kaji Etik',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          setTimeout(() => {
            this.$router.push({name: 'list-kajietik'})
          }, 1000);
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Kaji Etik',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
          setTimeout(() => {
            this.$router.push({name: 'list-kajietik'})
          }, 1000);
        }
      })
      .catch(error => console.log(error));
    },
    tolakBerkas(role)
    {
       var data = {
        role: role,
        catatan: this.catatanPenolakan,
        uuid: this.$route.params.uuid,
      }
      postTolakBerkas(data)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Kaji Etik',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          setTimeout(() => {
            this.$router.push({name: 'list-kajietik'})
          }, 1000);
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Kaji Etik',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
          setTimeout(() => {
            this.$router.push({name: 'list-kajietik'})
          }, 1000);
        }
      })
      .catch(error => console.log(error));
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
